import { SeverityLevel } from '../../input/materiality-assessment/types';

export function friendlySeverityLevel(level: SeverityLevel) {
  switch (level) {
    case SeverityLevel.NONE:
      return 'None';
    case SeverityLevel.LOW:
      return 'Low';
    case SeverityLevel.MEDIUM:
      return 'Medium';
    case SeverityLevel.HIGH:
      return 'High';
  }
}

export function friendlyShortSeverityLevel(level: SeverityLevel) {
  switch (level) {
    case SeverityLevel.NONE:
      return 'None';
    case SeverityLevel.LOW:
      return 'Low';
    case SeverityLevel.MEDIUM:
      return 'Med';
    case SeverityLevel.HIGH:
      return 'High';
  }
}

export function formatSeverityScoreToMaterialityScore(score: number) {
  const materialityScore = severityScoreToMaterialityScore(score);

  if (materialityScore === 0) {
    return '0';
  }

  if (materialityScore < 1) {
    return '< 1';
  }
  return materialityScore.toFixed(0);
}

export function severityScoreToMaterialityScore(score: number) {
  return score * 100;
}

export function materialityScoreToSeverityScore(score: number) {
  return score / 100;
}
